(function () {
  var tabs    = Array.from(document.querySelectorAll('.vss-guide__tab'));
  var panels  = document.querySelectorAll('.vss-guide__panel');
  var prevBtn = document.getElementById('vss-tab-prev');
  var nextBtn = document.getElementById('vss-tab-next');
  var counter = document.getElementById('vss-tab-counter');
  var prevLbl = document.getElementById('vss-prev-label');
  var nextLbl = document.getElementById('vss-next-label');
  var guide   = document.querySelector('.vss-guide');

  if (!tabs.length) return;

  function getActiveIndex() {
    return tabs.findIndex(function (t) {
      return t.getAttribute('aria-selected') === 'true';
    });
  }

  function updateNav(index) {
    var total   = tabs.length;
    var hasPrev = index > 0;
    var hasNext = index < total - 1;
    if (counter) counter.textContent = (index + 1) + ' / ' + total;
    if (prevBtn) {
      prevBtn.disabled = !hasPrev;
      if (prevLbl) prevLbl.textContent = hasPrev ? tabs[index - 1].textContent.trim() : '';
    }
    if (nextBtn) {
      nextBtn.disabled = !hasNext;
      if (nextLbl) nextLbl.textContent = hasNext ? tabs[index + 1].textContent.trim() : '';
    }
  }

  function scrollToGuide() {
    if (!guide) return;
    var scrollTarget = guide.getBoundingClientRect().top + window.pageYOffset - 20;
    window.scrollTo({ top: scrollTarget, behavior: 'smooth' });
  }

  function activate(index, scroll) {
    if (index < 0 || index >= tabs.length) return;
    tabs.forEach(function (t) { t.setAttribute('aria-selected', 'false'); });
    panels.forEach(function (p) { p.removeAttribute('data-active'); });
    tabs[index].setAttribute('aria-selected', 'true');
    var panel = document.getElementById(tabs[index].getAttribute('data-target'));
    if (panel) panel.setAttribute('data-active', '');
    updateNav(index);
    if (scroll) scrollToGuide();
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () { activate(i, false); });
  });

  if (prevBtn) prevBtn.addEventListener('click', function () { activate(getActiveIndex() - 1, true); });
  if (nextBtn) nextBtn.addEventListener('click', function () { activate(getActiveIndex() + 1, true); });

  updateNav(getActiveIndex());
})();


// ── Recommender ──────────────────────────────────────────────────────────────
function vssRecShow(val) {
  var results = document.querySelectorAll('.vss-rec__result');
  for (var i = 0; i < results.length; i++) {
    results[i].classList.remove('active');
  }
  if (val) {
    var target = document.getElementById('vss-rec-' + val);
    if (target) target.classList.add('active');
  }
}


// ── Accordion + .js-open-guide ───────────────────────────────────────────────
(function () {
  var trigger = document.getElementById('vss-accordion-trigger');
  var body    = document.getElementById('vss-accordion-body');

  if (!trigger || !body) return;

  function openAccordion() {
    trigger.setAttribute('aria-expanded', 'true');
    body.removeAttribute('hidden');
    body.style.gridTemplateRows = '1fr';
    body.style.visibility = 'visible';
  }

  function closeAccordion() {
    trigger.setAttribute('aria-expanded', 'false');
    body.setAttribute('hidden', '');
    body.style.gridTemplateRows = '0fr';
    body.style.visibility = 'hidden';
  }

  trigger.addEventListener('click', function () {
    if (trigger.getAttribute('aria-expanded') === 'true') {
      closeAccordion();
    } else {
      openAccordion();
    }
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-open-guide');
    if (!btn) return;
    e.preventDefault();
    openAccordion();

    setTimeout(function () {
      var accordion = document.querySelector('.vss-accordion');
      if (!accordion) return;
      accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 300);
  });

})();